'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT_MOUSE_BUTTON = 0;

var isLeftClick = exports.isLeftClick = function isLeftClick(mouseEvent) {
  var button = mouseEvent.button,
      altKey = mouseEvent.altKey,
      ctrlKey = mouseEvent.ctrlKey,
      shiftKey = mouseEvent.shiftKey,
      metaKey = mouseEvent.metaKey;

  return button === LEFT_MOUSE_BUTTON && !(altKey || ctrlKey || shiftKey || metaKey);
};

var stopPropagationHandler = exports.stopPropagationHandler = function stopPropagationHandler(evt) {
  if (evt) evt.stopPropagation();
};

var preventDefaultHandler = exports.preventDefaultHandler = function preventDefaultHandler(evt) {
  if (evt) evt.preventDefault();
};

/**
 * @param {InputEvent} evt
 * @returns {boolean} `true` if any modifier (alt, ctrl, meta, or shift) is pressed
 */
var isModifierPressed = exports.isModifierPressed = function isModifierPressed(evt) {
  return evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/DomEvents.js
// module id = 182
// module chunks = 3 4 5